const {
  REACT_APP_BASEURL_DEV,
  REACT_APP_BASEURL_QA,
  REACT_APP_BASEURL_PRD,
  REACT_APP_BASEURL_SRV_MAESTROS,
  REACT_APP_BASEURL_TRABAJADOR,
  REACT_APP_SEGURIDAD,
  REACT_APP_SEGURIDAD_USER,
  REACT_APP_SEGURIDAD_PASS,
  REACT_APP_LLAVE,
  REACT_APP_TOKEN,
  REACT_APP_EPAYCO_LLAVE,
  REACT_APP_BASEURL_EMPRESAS,
  REACT_APP_AMBIENTE_EPAYCO,
  REACT_APP_BASEURL_AKS
} = process.env;

export {
  REACT_APP_BASEURL_DEV,
  REACT_APP_BASEURL_QA,
  REACT_APP_BASEURL_PRD,
  REACT_APP_BASEURL_SRV_MAESTROS,
  REACT_APP_BASEURL_TRABAJADOR,
  REACT_APP_SEGURIDAD,
  REACT_APP_SEGURIDAD_USER,
  REACT_APP_SEGURIDAD_PASS,
  REACT_APP_LLAVE,
  REACT_APP_TOKEN,
  REACT_APP_EPAYCO_LLAVE,
  REACT_APP_BASEURL_EMPRESAS,
  REACT_APP_AMBIENTE_EPAYCO,
  REACT_APP_BASEURL_AKS
};
